import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ColorModule } from '../color/color.module';

import { BoxSmallHeaderDirective, BoxSmallContentDirective, BoxSmallFooterDirective } from './box-small.directive';
import { BoxSmallComponent } from './box-small.component';
export class BoxSmallModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ColorModule],
    exports: [BoxSmallComponent, BoxSmallHeaderDirective, BoxSmallContentDirective, BoxSmallFooterDirective],
    declarations: [BoxSmallComponent, BoxSmallHeaderDirective, BoxSmallContentDirective, BoxSmallFooterDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxSmallModule_tsickle_Closure_declarations() {
/** @type {?} */
BoxSmallModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxSmallModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
